import { AxiosRequestConfig } from 'axios';
import { batch } from 'react-redux';
import { EmeraldError } from 'src/common/api/emerald-error';
import { emeraldRequest } from 'src/common/api/emerald-request';
import XLRLogger from 'src/common/helpers/logger';
import { ISellableTenders } from 'src/common/interfaces/dtos/ISellableTenders';
import { ITender } from 'src/common/interfaces/dtos/ITender';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { store } from 'src/common/redux/configure-store';
import { CashOfficeActions } from 'src/common/redux/reducers/cash-office-reducer';
import { ActiveTenderRequestOptions } from '../interfaces/ActiveTenderRequestOptions';

export const getActiveTenders = async (
  requestType: Partial<ActiveTenderRequestOptions>,
): Promise<void> => {
  const sellableTenders: ISellableTenders = {
    tenderGroups: [],
    rawTenders: [],
  };

  await getTenderService(requestType)
    .then((activeTenders: ITender[]): void => {
      if (activeTenders?.length) {
        sellableTenders.rawTenders = activeTenders;
        setTendersInTenderGroup(sellableTenders);
        updateTenderMenu(sellableTenders);
      } else {
        clearTenderMenu();
        throw new EmeraldError('NoTenders');
      }
    })
    .catch(err => {
      XLRLogger.error({
        message: 'Unable to fetch active tenders for cash office activities',
        source: 'get-active-tenders.ts',
        data: err,
      });
      clearTenderMenu();
      throw new EmeraldError('NoTenders');
    });
};

const setTendersInTenderGroup = (sellableTenders: ISellableTenders): void => {
  if (sellableTenders.rawTenders && sellableTenders.rawTenders.length) {
    sellableTenders.rawTenders.forEach((tender, index) => {
      sellableTenders.tenderGroups[index] = {
        tenderCountList: [],
        tenders: [tender],
        name: tender.description,
      };
    });
  }
};

const updateTenderMenu = (sellableTenders: ISellableTenders): void => {
  batch((): void => {
    store.dispatch(CashOfficeActions.setTenderMenu(sellableTenders));
    store.dispatch(CashOfficeActions.setSelectedTenderGroup(sellableTenders.tenderGroups[0].name));
  });
};

const clearTenderMenu = (): void => {
  store.dispatch(CashOfficeActions.resetState());
};

const getTenderService = async (
  requestType: Partial<ActiveTenderRequestOptions>,
): Promise<ITender[]> => {
  const axiosConfig: AxiosRequestConfig = {
    url: '/tenders',
    method: 'GET',
    params: requestType,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<ITender[]>(emeraldRequestParams);
};
